<template>
  <div id="content" class="manage_default_data">

    <ConfirmModal :dialogVisible='showConfirmClose' @close="showConfirmClose = false" @confirmed="realCloseAssessment($event)" message="Are you sure you want to close this assessment? It will no longer be available to your judges." ></ConfirmModal>

    <div class="" v-show="assessment && criteriaGroups" >
      <VoteNextStep @close="showNextStep=false;" :assessment="assessment" :vote="voteFor" :judgesVote="judgesVote" :criteriaGroups="criteriaGroups" :dialogVisible="showNextStep"/>
      <NextStep  @end='end' @close="voteNextStep=false;" :assessment="assessment" :vote="voteFor" :dialogVisible="voteNextStep"/>

    </div>
    <div class="" v-if="errorAssessmentNotExist">
      <div class="alert alert-warning">
        {{$t("Assessment is no more available")}}
      </div>
    </div>
    <div class="assessment-navigation" v-if='assessment && !errorAssessmentNotExist'>
      <div class="left">

            <router-link to="/manage_assessments" class="back-button" >
              <v-img :src="require('@/assets/backArrowBlue.svg')" alt=""></v-img>
              Back
        </router-link >
        <span class="aname" v-if="assessment.name"> {{ assessment.name }}</span>
        <span class="aname" v-else>{{ $t("My assessment")}}</span>
        <div class="status inprogress" v-if="assessment.status == 'progress'">
            <span class="status-text">{{ $t("In progress")}}</span>
        </div>
        <div class="status draft" v-if="assessment.status == 'draft'">
            <span class="status-text">{{ $t("Draft")}}</span>
        </div>
        <div class="status completed" v-if="assessment.status == 'completed'">
            <span class="status-text">{{ $t("Completed")}}</span>

        </div>
        <div class="status closed" v-if="assessment.status == 'closed'">
            <span class="status-text">{{ $t("Closed")}}</span>

        </div>
      </div>
      <div class="right">
        <a class="preview-button" target="_blank" :href="'/internalassessment_preview/'+assessment._id.$oid">
            Preview
        </a>
        <button class="next-button" @click="closeAssessment" v-if="assessment.status != 'closed'">
            Close
        </button>
      </div>

  </div>
    <div class="content_div stats mt20" v-if="assessment_results && assessment">
      <div class="headerResutls">
        <div class="participation" v-if="assessment">
          <span>{{ $t("Judges participations")}} : {{judge_participation.length}} / {{assessment.judges.length}}</span>
        </div>
        <div class="messagepromopub">
          Drive your partnership success.
          <br/>
          <a href="https://outlook.office365.com/book/innopearl@innopearl.ch/" target="_blank" class="bluehover"><strong>Try 360-degree innovator assessment</strong></a>
        </div>
      </div>
      <div class="searchbar">
        <div class="quicksearch">
            <input type="text" class="input" placeholder="Search by name"  v-model="quicksearch">
        </div>
      </div>
      <div class=" toprated confirmedSelection" >
        <div class="" v-if="confirmedResultsFrom.length > 0">
          <div class="row text-center">
            <span class="titleText">{{ $t('Confirmed selection')}}</span>

          </div>
          <div class="row listOfSelectedStartups">
            <div class="col-12 col-lg-6 col-xl-4 candidate" v-for="(vote,r) in confirmedResultsFrom" :key="r">
              <div class="candidate_card selectCandidateCard">

                <div class="interestLevel" v-if="vote.confirmed_result.nextstep_info" >
                   <span class="nextstepinfoitem">{{vote.confirmed_result.nextstep_info.name}}</span>

                </div>
                  <div class="candidate_card_head">
                       <img :src="require('@/assets/assessDone.svg')"  alt=""/>
                      <span class="name">{{vote.startup.name}}</span>

                  </div>

                  <div class="avgVote">
                    <span class="avgValue"> {{ formattedNumber(vote.averageVotePerStartup) }}&nbsp;/&nbsp;5</span>
                    <div class="detailNote" @click="viewVoteDetail(vote)">
                      <span>Average Score </span>
                      <img :src="require('@/assets/infoCriteria.svg')"  alt=""/>
                    </div>
                    <VoteResultsDetails v-click-outside="hideDetails"  :criteriaGroups="criteriaGroups" :vote="vote" v-if="showDetailsSelected == vote.startup._id.$oid"/>

                  </div>
                  <div class="candidate_info_content">
                    <span class="titreProperty">Value proposition</span>
                    <span class="valueProperty" v-if="vote.startup.value_proposition">{{vote.startup.value_proposition}}</span>
                    <span class="valueProperty" v-else>No data</span>

                  </div>
                  <div class="interest">
                    <InterestRepartitionDetails  :vote="vote"/>

                  </div>

                  <div class="moreDetails">
                      <button @click="toggleShowNextStep(vote)">More details</button>
                  </div>

                  <div class="confirmAssessment">

                    <button @click="toggleNextStep(vote)" class="confirmAssessmentBtn">
                      <span>Next step</span>
                      <img :src="require('@/assets/nextStep.svg')"  alt=""/>

                    </button>


                  </div>

              </div>
            </div>

          </div>
        </div>


        <div class="row text-center">
          <span class="titleText">{{ $t('Top-rated innovators')}}</span>
        </div>
        <div class="row listOfSelectedStartups">
          <div class="col-12 col-lg-6 col-xl-4 candidate" v-for="(vote,r) in topRatedResults" :key="r">
            <div class="candidate_card selectCandidateCard">
              <div class="interestLevel">
                <span class="high" v-if="vote.averageVotePerStartup >= 4 ">{{$t("TOP RATED")}}</span>
                <span class="medium"  v-else-if="vote.averageVotePerStartup >= 3 ">{{$t("AVERAGE RATING")}}</span>

                <span class="low"  v-else>{{$t("BELOW AVERAGE RATING")}}</span>

              </div>
                <div class="candidate_card_head">
                    <!-- <img :src="require('@/assets/assessDone.svg')"  alt=""/> -->
                    <span class="name">{{vote.startup.name}}</span>

                </div>

                <div class="avgVote">
                  <span class="avgValue"> {{ formattedNumber(vote.averageVotePerStartup) }}&nbsp;/&nbsp;5</span>
                  <div class="detailNote" @click="viewVoteDetail(vote)">
                    <span>Average Score </span>
                    <img :src="require('@/assets/infoCriteria.svg')"  alt=""/>
                  </div>
                  <VoteResultsDetails v-click-outside="hideDetails"  :criteriaGroups="criteriaGroups" :vote="vote" v-if="showDetailsSelected == vote.startup._id.$oid"/>

                </div>
                <div class="candidate_info_content">
                  <span class="titreProperty">Value proposition</span>
                  <span class="valueProperty" v-if="vote.startup.value_proposition">{{vote.startup.value_proposition}}</span>
                  <span class="valueProperty" v-else>No data</span>

                </div>
                <div class="interest">
                  <InterestRepartitionDetails  :vote="vote"/>

                </div>

                <div class="moreDetails">
                    <button @click="toggleShowNextStep(vote)">More details</button>
                </div>

                <div class="confirmAssessment">

                  <button  v-if="assessment.status == 'completed'" @click="toggleNextStep(vote)" class="confirmAssessmentBtn">Confirm</button>

                </div>

            </div>
          </div>
          <div class="" v-if="topRatedResults.length == 0">
             {{$t("All top-rated innovators have been added")}}
          </div>
        </div>
      </div>
      <div class="other_results">


        <div class="row listOfSelectedStartups" v-if="notTopRatedResults.length > 0">
          <div class="col-12 col-lg-6 col-xl-4 candidate" v-for="(vote,r) in notTopRatedResults" :key="r">
            <div class="candidate_card selectCandidateCard">
              <div class="interestLevel">
                <span class="high" v-if="vote.averageVotePerStartup >= 4 ">{{$t("TOP RATED")}}</span>
                <span class="medium"  v-else-if="vote.averageVotePerStartup >= 3 ">{{$t("AVERAGE RATING")}}</span>

                <span class="low"  v-else>{{$t("BELOW AVERAGE RATING")}}</span>

              </div>
                <div class="candidate_card_head">
                    <!-- <img :src="require('@/assets/assessDone.svg')"  alt=""/> -->
                    <span class="name">{{vote.startup.name}}</span>

                </div>

                <div class="avgVote">
                  <span class="avgValue"> {{ formattedNumber(vote.averageVotePerStartup) }}&nbsp;/&nbsp;5</span>
                  <div class="detailNote" @click="viewVoteDetail(vote)">
                    <span>Average Score </span>
                    <img :src="require('@/assets/infoCriteria.svg')"  alt=""/>
                  </div>
                  <VoteResultsDetails v-click-outside="hideDetails"  :criteriaGroups="criteriaGroups" :vote="vote" v-if="showDetailsSelected == vote.startup._id.$oid"/>

                </div>
                <div class="candidate_info_content">
                  <span class="titreProperty">Value proposition</span>
                  <span class="valueProperty" v-if="vote.startup.value_proposition">{{vote.startup.value_proposition}}</span>
                  <span class="valueProperty" v-else>No data</span>

                </div>
                <div class="interest">
                  <InterestRepartitionDetails  :vote="vote"/>

                </div>
                <div class="moreDetails">
                    <button @click="toggleShowNextStep(vote)">More details</button>
                </div>

                <div class="confirmAssessment">

                  <button  v-if="assessment.status == 'completed'" @click="toggleNextStep(vote)" class="confirmAssessmentBtn">Confirm</button>

                </div>



            </div>
          </div>


          </div>
      </div>
    </div>

  </div>
</template>
<script>

  import api from '../tools/api';
 import { toast } from 'vue-sonner';
 import VoteResultsDetails from '@/components/VoteResultsDetails.vue'
 import InterestRepartitionDetails from '@/components/InterestRepartitionDetails.vue'
 import VoteNextStep from '@/components/VoteNextStep.vue'
 import NextStep from '@/components/NextStep.vue'
 import ConfirmModal from '@/components/modals/ConfirmModal.vue'


export default {
  components: {
    VoteResultsDetails,
    InterestRepartitionDetails,
    VoteNextStep,
    NextStep,
    ConfirmModal
    // SidebarJudge,
    // JudgeViewSummary
    // QuillEditor,
    // CreateCriteriaModal,
  //   CriteriaDetails,
  //  StartupInfoLine
  },
  name: 'AssessmentResults',
  data() {
    return {
      dialog:false,
      pageInfo: {
        mainTitle : "My assessment space ",
        subTitle : this.$t("View results"),
      },
      quicksearch:'',
      aid : null,
      assessment_results:null,
      assessment : null,
      voteNextStep:null,
      errorAssessmentNotExist:false,
      judge_participation : 0,
      forceRecompute:true,
      nextStepFor:null,
        voteFor:null,
        judgesVote:[],
      showDetailsSelected:null,
      showNextStep: false,
      showConfirmClose:false,
      confirmed_results: [],
    }
  },
  methods:{
    toggleShowNextStep(vote){
      console.log("vote",vote);
      api.get(process.env.VUE_APP_API_URL+"/restrict/judges_votes/"+this.aid+"/"+vote.startup._id.$oid).then( (r) => {
        this.judgesVote = r.data;
        this.voteFor = vote;
        this.showNextStep = true;
      }).catch( (e) => {
        console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

      });

    },
    toggleNextStep(vote){

        this.voteFor = vote;
        this.voteNextStep = true;
    },
    end(){
    //   this.voteFor.confirmed_result = v;
       this.voteNextStep= false;
    //   if(this.confirmed_results.length > 0){
    //     this.confirmed_results = this.confirmed_results.map(item =>
    //       item._id.$oid == v._id.$oid ? v : item
    //     );
    //   }
    //   else{
    //       this.confirmed_results.push(v);
    //   }
    //
    //   this.assessment_results = this.assessment_results.map(item => {
    //
    //   if (item.startup._id.$oid === this.voteFor.startup._id.$oid) {
    //     const updatedItem = {
    //       ...item,
    //       confirmed_result: v // Update the field you want to modify
    //     };
    //
    //     return updatedItem;
    //   }
    //   return item;
    // });
    // this.assessment_results = [...this.assessment_results];
    //this.getAssessmentResults();
    this.getConfirmedResults();
    },
    getAssessmentResults(){
      api.get(process.env.VUE_APP_API_URL+"/restrict/assessment_results/"+this.aid).then( (r) => {
        console.log("asvoting",r.data);
        this.assessment_results = r.data;
      }).catch( (e) => {
        console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

      });
    },
    hideDetails(){
      this.showDetailsSelected = null; // Hide if already visible
    },
    formattedNumber(number) {
          return new Intl.NumberFormat('fr-FR', {
            style: 'decimal',
            minimumFractionDigits: 0,
            maximumFractionDigits: 1
          }).format(number);
    },
    viewVoteDetail(vote){
      console.log(vote);
      this.showDetailsSelected = vote.startup._id.$oid;
    },
    closeAssessment(){
      this.showConfirmClose = true;
    },
    hideConfirmClose(){
        this.showConfirmClose = false;
    },
    realCloseAssessment(){
      this.showConfirmClose = false;
      api.post(process.env.VUE_APP_API_URL+"/restrict/close_assessment",
        {assessment : this.assessment},
        { headers: {'Content-Type': 'application/json',}}
      ).then( () => {
          this.getAssessment();
          toast.success(this.$t("The assessment is  complete! "));

        }).catch( (e) => {
          console.log(e);
          toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")
        });
    },
    getAssessment(){
      api.get(process.env.VUE_APP_API_URL+"/restrict/assessment/"+this.aid).then( (r) => {
        this.assessment = r.data;
          this.errorAssessmentNotExist = false;
      }).catch( (e) => {
        console.log(e);
        this.errorAssessmentNotExist = true;
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

      });
    },
    getConfirmedResults(){
      api.get(process.env.VUE_APP_API_URL+"/restrict/confirmed_results/"+this.aid).then( (r) => {
        this.confirmed_results = r.data;
        console.log('dfgsopgfdsogp^sdofgfsdg', this.confirmed_results);
      }).catch( (e) => {
        console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

      });
    },
    getJudgeParticipation(){
      api.get(process.env.VUE_APP_API_URL+"/restrict/getJudgeParticipation/"+this.aid).then( (r) => {
        this.judge_participation = r.data;
      }).catch( (e) => {
        console.log(e);
        toast.error("Oops! Something went wrong. Please try again or Contact us if problem persists. ")

      });
    },

  },
  mounted(){
    this.aid = this.$route.params.id;
    //if(this.$route.params.id != "undefined"){
      this.getAssessmentResults();
      this.getAssessment();
      this.getJudgeParticipation();
      this.getConfirmedResults();
     this.$store.commit('UPDATE_PAGE_INFO',this.pageInfo)

     api.get(process.env.VUE_APP_API_URL+"/restrict/mycriteriabygroup").then( (r) => {
       this.criteriaGroups = r.data;

       console.log(r);
     }).catch( (e) => console.log(e));

  },
  computed:{
    confirmedResultsFrom(){
      var startup_confirmed = new Set(this.confirmed_results.map(c => c.startup.$oid));

      return this.assessment_results.filter(item => {
        if(this.quicksearch){
          if(item.startup.name.toUpperCase().includes(this.quicksearch.toUpperCase())){
            if(startup_confirmed.has(item.startup._id.$oid)) return true;
          }
        }
        else{
          if(startup_confirmed.has(item.startup._id.$oid)) return true;
        }

      })
      .map(item => {
         var confirmed = this.confirmed_results.find(c => c.startup.$oid === item.startup._id.$oid);

         return {
           ...item,
           confirmed_result: confirmed
         };
       })
       .sort((a, b) => {
      // Primary sort by nextstep_info.order (descending)

      const orderA = a.confirmed_result.nextstep_info?.order ?? 0; // Default to 0 if order is missing
      const orderB = b.confirmed_result.nextstep_info?.order ?? 0;

      if (orderA !== orderB) return orderB - orderA;

      // Secondary sort by averageVotePerStartup (descending)
      return b.averageVotePerStartup - a.averageVotePerStartup;
    });
      //.sort((a, b) => b.averageVotePerStartup - a.averageVotePerStartup);


    },
    topRatedResults(){
      var startup_confirmed = new Set(this.confirmed_results.map(c => c.startup.$oid));
      var filteredItems = this.assessment_results.filter(item => {
        if(this.quicksearch){
          if(item.startup.name.toUpperCase().includes(this.quicksearch.toUpperCase())){
            if(item.averageVotePerStartup >= 4 && !startup_confirmed.has(item.startup._id.$oid)) return true;
          }
        }
        else{
          if(item.averageVotePerStartup >= 4 && !startup_confirmed.has(item.startup._id.$oid)) return true;
        }

      }).sort((a, b) => b.averageVotePerStartup - a.averageVotePerStartup);
      return filteredItems;
    },
    notTopRatedResults(){
      var startup_confirmed = new Set(this.confirmed_results.map(c => c.startup.$oid));

      var filteredItems = this.assessment_results.filter(item => {
        if(this.quicksearch){
          if(item.startup.name.toUpperCase().includes(this.quicksearch.toUpperCase())){
            if(item.averageVotePerStartup < 4 && !startup_confirmed.has(item.startup._id.$oid)) return true;

          }
        }
        else{
          if(item.averageVotePerStartup < 4 && !startup_confirmed.has(item.startup._id.$oid)) return true;
        }

      }).sort((a, b) => b.averageVotePerStartup - a.averageVotePerStartup);
      return filteredItems;
    },
  },

  }
</script>


<style scoped>

.manage_default_data{
  padding-top:50px;
  padding-bottom: 50px;
  padding: 50px;
}
.content_div{
  /* margin-top:50px;
  margin-bottom: 50px; */
  padding: 50px;
          border-radius:20px;
  background: #FFFFFF 0% 0% no-repeat padding-box;

}


.header{
  display:flex;
  width:100%;
}

.header > div{
  width:calc(100% / 3);

}

.header .StatusAndDeadline{
  display:flex;
  gap:20px;
    align-items: center;
}

.header .status{
  display:flex;
  gap:5px;
  align-items: center;
}


.statusLabel,
.deadlineTitle,
.judgeTitle{
  font-size:20px;
  color:#000;
  font-weight: 300;
}

.deadlineValue{
  color:#B00020;
  font-size:16px;
  font-weight: 400;
}
.judgeName{
color:#3982C4;
font-size:16px;
font-weight: 400;
}

.assessmentName{
  font-size:20px;
  color:#000;
  font-weight: 700;
  text-align: center;
}

.judgeInfo{
  text-align:right;
}

.description{
  margin-top:50px;
}
.right{
  display:flex;
  gap:10px;
  flex-wrap: wrap;
}

@media screen and (max-width:990px){
  .header{
    flex-direction: column;
    gap:10px;
  }
  .header > div{
    width:100% !important;
    text-align:center;
  }
  .header .StatusAndDeadline{
    justify-content: center;
  }
}


#Completedassessments{
  margin-top:50px;
  padding:50px;
}

#startuoToAssess{
  margin-top:50px;
  padding:50px;
  background:rgba(245, 250, 255, 1);
  border-radius: 15px;
}
#Completedassessments .titleText,
#startuoToAssess .titleText{
  font-size:20px;
  font-weight: 700;
  text-align:center;
  color:rgba(4, 36, 106, 1);
}



  .selectCandidateCard{
    background:#FFF;
  }
  .selectCandidateCard  .candidate_card_head{
      color: #4c81c0 !important;
      padding: 10px 0px;
      background: #FFF;
      text-transform: uppercase;
      font-weight: bold;
    margin-left: 20px;
    margin-right: 20px;
      display:flex;
      align-content: center;
        align-items: center;
    gap:10px;
    min-height: 60px;

  }

.candidate{
  margin-top:20px;
  margin-bottom: 20px;
  position:relative;
}
.candidate_card{
  border: 2px solid #DDDDDD;
border-radius: 15px;
z-index: 5;
height:100%;
display: flex;
flex-direction: column;
}
.candidate_card .candidate_image{
  width:100%;
  height:200px;
  object-fit: cover;
  z-index: 1;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.clickable{
  cursor:pointer;
}
.candidate_card .candidate_links{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 20px 5px;

  margin: 0;
}
.candidate_card .candidate_info_content{
  padding:10px 20px ;
  flex-grow: 1;
}
.candidate_card .candidate_info_content .candidate_name{
  font-size:18px;
  line-height:21px;
letter-spacing: 0px;
color: #3783C5;
text-transform: uppercase;
display:block;
font-weight: 500;
}

.candidate_card .candidate_info_content .candidate_desc{
  font-size:16px;
  line-height:22px;
  margin-top:10px;
  display:block;
  margin-bottom:10px;
}
.candidate_card .candidate_links .details{
  font-size:12px;
  line-height: 15px;
  border-right: 1px solid #DDD;
  display:flex;
  align-items: center;
  text-transform: uppercase;
  color: #3783C5;
  flex: 0.5;

}
.candidate_card .candidate_links .details a{
    text-decoration: none;
}
.candidate_card .candidate_links .details img{
  margin-right:5px;
}
.candidate_card .candidate_links .selectIt{
  font-size:12px;
  line-height: 15px;
  letter-spacing: 0px;
  color: #3783C5;
  text-transform: uppercase;
  flex:0.5;
  align-items: flex-end;

}

.candidate_card .candidate_links .selectIt_fw{
  flex:1;
  align-items: flex-start;
}
.candidate_card .candidate_links .selectIt_fw label{
display:flex;
align-items: center;
gap: 5px;
justify-content: start;
}
.candidate_card .candidate_links .selectIt label{
display:flex;
align-items: center;
gap: 5px;
justify-content: end;
}
.candidate_card .candidate_links .selectIt input{
  width:24px;
  height:24px;
}
.candidate_card .candidate_links .details.noBorder{
  border-right: none;

}

  .selectCandidateCard .titreProperty{
    color:rgba(75, 82, 162, 1);
    font-size:14px;
    font-weight: 400;
    width:100%;
    display:block;
  }
  .selectCandidateCard .valueProperty{
    color:rgba(10, 32, 113, 1);
    font-size:14px;
    font-weight: 700 !important;
    width:100%;
    display:block;
  }

  .footer_link_cc{
 padding-left:20px;
 padding-right:20px;
 margin-bottom:20px;
 margin-top:20px;
  }
  .footer_link_cc a{
      display:block;
      width:100%;
      background:#4c81c0;
      color:#FFF;
      border-radius: 10px;
      padding:10px;
      text-align: center;
  }

  .listOfSelectedStartups{
    margin-top:25px;
  }
  .avgVote{
    padding-left:20px;
    padding-right:20px;
    display:flex;
    gap:10px;
    align-items: center;
    position:relative;
  }
  .avgValue{
    font-weight: 100;
    font-size:32px;
    color:#0A2071;
  }

  .detailNote{
    display:flex;
    gap:10px;
  }
  .detailNote span{
    font-weight: 100;
    color: #0A2071;
  }
  .detailNote img{
    width:16px;
  }


.oneInfoAboutValue p{
  padding:0;
  margin:0;
}

.interestLevel{
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 100%;
  text-align: center;
}
.interestLevel .low{
  background:#FFE2E5;
  padding:4px 8px;
  font-size:14px;
  font-weight: 700;
  color:#FA5A7D;
  border-radius:20px;
}
.interestLevel .medium{
  background:#FFF4DE;
  padding:4px 8px;
  font-size:14px;
  font-weight: 700;
  color:#FFAA2A;
  border-radius:20px;
}
.interestLevel .high{
  background:#E7FFEF;
  padding:4px 8px;
  font-size:14px;
  font-weight: 700;
  color:#3AC851;
  border-radius:20px;
}
.interestLevel .nextstepinfoitem{
  background: #E1E7EE;
    padding: 4px 8px;
    font-size: 14px;
    font-weight: 700;
    color: #4B81C0;
    border-radius: 20px;
}

.candidate_card .interest{
  margin-left:20px;
  margin-right:20px;
  margin-bottom: 50px;
  margin-top:20px;
}
.confirmedSelection{
  margin-top:50px;
}
.listOfSelectedStartups{
    margin-bottom:50px;
}
.confirmedSelection{
  margin-top:50px;
}
.listOfSelectedStartups{
    margin-bottom:50px;
}
.toprated{
    padding:50px;
    background:rgba(245, 250, 255, 1);
    border-radius: 15px;

}



.other_results{

  padding:50px;
}
@media screen and (max-width:990px){
  .toprated{
      padding:20px;

  }
  .other_results{

    padding:20px;
  }

  .content_div{
    padding:20px;
  }
}

.titleText{
  font-size:20px;
  font-weight: 700;
  text-align:center;
  color:rgba(4, 36, 106, 1);
}

.participation{
  font-size:20px;
}



.assessment-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #fff;
    width: 100%;
        background-color: #fbfbfb;
        padding:20px;
        border-radius:20px;
}




.preview-button {
    color: #3783C5 !important;
    background: #fff 0% 0% no-repeat padding-box;
    border:1px solid #3783C5 !important;
    padding: 10px 27px;
    border: none;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 200px;
    text-transform:uppercase;
}
.next-button {
    color: #fff;
    background: #3783C5 0% 0% no-repeat padding-box;
    border:1px solid #3783C5;
    padding: 10px 27px;
    border: none;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 200px;
    text-transform:uppercase;
}
.back-button{
      color: #3783C5;
      background: # 0% 0% no-repeat padding-box;
      padding: 10px 20px;
      border: none;
      display: flex;
      align-items: center;
          cursor: pointer;
          gap:5px;
          border-radius: 200px;
          border:1px solid #3783C5;
          text-transform:uppercase;

}


.status{
  gap:5px;
}
.status.inprogress {
    display: flex;
    align-items: center;
    background-color: #FFAA2A;
      padding: 5px 20px !important;
    border-radius: 15px;
}

.status.inprogress .status-text {
    color: #fff;
    font-size: 14px;
}
.status.draft {
    display: flex;
    align-items: center;
    background-color: #6C68A2;
      padding: 5px 20px !important;
    border-radius: 15px;
}


.status.draft .status-text {
    color: #fff;
    font-size: 14px;
}

.status.completed {
    display: flex;
    align-items: center;
    background-color: #4ADE80;
      padding: 5px 20px !important;
    border-radius: 15px;
}

.status.completed .status-text {
    color: #FFF;
    font-size: 14px;
}


.status.closed {
    display: flex;
    align-items: center;
    background-color: #ADB3B5;
      padding: 5px 20px !important;
    border-radius: 15px;
}

.status.closed .status-text {
    color: #fff;
    font-size: 14px;
}

.next-button .v-img{
  margin-left:10px;
}

.left{

  flex: 1;
  display: flex;
  align-items: center;
  gap: 20px;
}
@media screen and (max-width:990px){
  .assessment-navigation{
    flex-direction: column;
        align-items: left;
    gap:20px;
    padding: 10px;
  }

  .left {
    flex-wrap: wrap;
  }
}
.moreDetails{
  text-align:center;
  color:#4B81C0;
  margin-bottom:20px;
  margin-left:20px;
  margin-right:20px;
}
.moreDetails button{
  text-decoration:underline;
}

.confirmAssessmentBtn{
  display:flex;
  gap:20px;
  justify-content: center;
  align-items: center;
  color:#FFF;
  font-size:16px;
  background:#4B81C0;
  margin:20px;
  margin-top:0px;
  width:calc(100% - 40px);
  padding:10px;
  border-radius: 5px;
}
.mt50{
  margin-top:50px;
}

.oneDetail{
  width:100%;
}

.headerResutls{
  width:100%;
  display:flex;
  text-align:center;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.bluehover{
  color:inherit;
}
.bluehover:hover{
  color:#3783C5;
}

  .quicksearch{
    position:relative;
    display:inline-block;
  }
  .quicksearch .input{
    max-width:300px;
      border: 1px solid #3783C5;
      background: transparent;
      padding: 10px 20px;
      padding-right: 50px;
      border-radius: 200px;
      outline: none;
      color: #3783C5;
      font-weight: bold;
      letter-spacing: 1px;
  }
  .quicksearch::after{
    content: url('@/assets/loupe.svg');
    position:absolute;
    right:15px;
    right: 15px;
      top: calc(50% - -1px);
    transform:translateY(-50%);
  }


  .searchbar{
    margin-top:25px;
    position:relative;
  }

  @media screen and (max-width:990px){
    .quicksearch{
      max-width: 100%;
      width:100%;
      margin-top:20px;
      margin-bottom:20px;
    }
    .quicksearch .input{
      max-width: 100%;
      width:100%;
        /* border: 1px solid #fff;
        background: transparent;
        padding: 5px 20px;
        border-radius: 200px;
        outline: none;
        color: #fff;
        font-weight: bold;
        letter-spacing: 1px; */
    }
  }



    .gold-button {
        color: #BF9000;
        background: #FFF 0% 0% no-repeat padding-box;
        padding: 10px 27px;
        border: none;
        display: flex;
        gap:10px;
        align-items: center;
        cursor: pointer;
        border-radius: 200px;
        border:1px solid #BF9000;
    }

    @media screen and (min-width:1351px) and (max-width:1650px){
      .candidate {
        flex: 0 0 auto;
        width: calc(100% / 3);
      }

    }
    @media screen and (min-width:1000px) and (max-width:1350px){
      .candidate {
        flex: 0 0 auto;
        width: 50%;
      }

    }

</style>
